"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_uid_1 = require("react-uid");
const react_multi_carousel_1 = __importDefault(require("react-multi-carousel"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const helpers_1 = require("../../../../common/helpers/helpers");
const modalEnums_1 = __importDefault(require("../../../../common/modalEnums"));
const globalVariables_1 = require("../../../../common/globalVariables");
require("react-multi-carousel/lib/styles.css");
const WrapperList = styled_components_1.default.div `
  .simple-scroller {
    display: flex;
    overflow-x: scroll;

    padding-bottom: 16px;
    height: 180px;

    @media (min-width: 1025px) {
      display: none;
    }

    .item-wrapper-small {
      flex-shrink: 0;

      width: calc(50% - 10px); // 2full

      @media (min-width: 600px) {
        width: calc(33% - 8px); // 3full
      }

      @media (min-width: 768px) {
        width: calc(17% - 9px); // 6 full
      }

      @media (min-width: 1023px) {
        width: calc(14% - 6px); // 6 full
      }
    }

    .item-wrapper {
      flex-shrink: 0;
      width: calc(100% - 18px); // 1full
      @media (min-width: 375px) {
        width: calc(50% - 18px); // 2full
      }

      @media (min-width: 460px) {
        width: calc(31% - 8px); // 3full
      }

      @media (min-width: 1023px) {
        width: calc(24% - 9px); // 6 full
      }
    }
  }

  margin: 0 auto;
  width: auto;
  position: relative;
  max-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_CONTENT}px;

  @media (min-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_CONTENT}px) {
    margin-top: 25px;
  }

  .lists-content {
    padding: 0 16px;
    max-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_CONTENT}px;

    @media (min-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_WITH_BUTTONS}px) {
      margin: 0 auto;
      padding: 0;
    }
  }

  .list {
    &-items {
      display: none;

      @media (max-width: 767px) {
        position: relative;
      }

      @media (min-width: 1025px) {
        position: relative;
        display: flex;
      }
    }

    &-header {
      display: flex;
      justify-content: space-between;
      padding-bottom: 15px;
      margin-top: 25px;
      align-items: center;

      @media (min-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_CONTENT}px) {
        margin-top: 50px;
      }

      &-title {
        font-weight: 500;
        letter-spacing: 0.25px;
      }

      &-link {
        text-transform: uppercase;
        font-weight: 500;
        letter-spacing: 1.25px;
        font-size: 14px;
        color: ${(props) => props.theme.palette.mainAppColor.main};
      }
    }
  }

  .item-wrapper {
    height: 100%;
    width: 100%;
    padding-right: 10px;
    cursor: pointer;
  }

  .item {
    &-wrapper {
      position: relative;
    }

    &-image {
      object-fit: cover;
      border-radius: 10px;
      position: relative;
      width: 100%;
    }

    &-title {
      font-size: 1.25rem;
      bottom: 30px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 90%;
    }

    &-info {
      bottom: 10px;
      letter-spacing: 0.5px;
    }
  }

  .item-texts {
    color: #fff;
    position: absolute;
    font-weight: 400;
    z-index: 3;
    bottom: 10px;
    width: 100%;
    padding-left: 8px;
    .item-info {
      color: white;
    }

    .item-title {
      color: white;
    }
  }

  .backup-gradient {
    height: 100%;
    width: 100%;
    border-radius: 10px;
    background: linear-gradient(
      10deg,
      ${(props) => props.theme.palette.mainAppColor.dark} 25%,
      ${(props) => props.theme.palette.mainAppColor.light} 47%,
      ${(props) => props.theme.palette.mainAppColor.main} 100%
    );
  }

  .wrapper-image {
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;

    &:before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        to top,
        rgba(0, 0, 0, 0.5) 33%,
        rgba(0, 0, 0, 0) 100%
      );
      z-index: 2;
      border-radius: 10px;
    }
  }

  .carousel-wrapper {
    position: inherit;

    .react-multi-carousel-item {
      height: 180px;
    }

    .react-multiple-carousel__arrow {
      min-width: 38px;
      min-height: 38px;
      display: none;

      @media (min-width: 767px) {
        display: block;
      }

      &--left,
      &--right {
        background-color: #fff;
        border: 2px solid ${(props) => props.theme.palette.mainAppColor.main};

        &:before {
          color: ${(props) => props.theme.palette.mainAppColor.main};
          font-weight: 700;
        }
      }

      &--left {
        left: 0;

        @media (min-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_WITH_BUTTONS}px) {
          left: -16px;
        }
      }

      &--right {
        right: 0;

        @media (min-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_WITH_BUTTONS}px) {
          right: -16px;
        }
      }
    }
  }

  .list-header-title {
    @media (min-width: 769px) {
      font-size: 1.5rem; // h5
    }
  }
`;
// we need to set partialVisibilityGutter based on items available due to a bug that messes up the layout if the shown items are equal to the all available items
const getResponsiveSettings = (itemsAvailable) => ({
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 4,
        slidesToSlide: 4,
        partialVisibilityGutter: itemsAvailable === 4 ? 0 : 20,
    },
    tablet: {
        breakpoint: { max: 1023, min: 768 },
        items: 3,
        slidesToSlide: 3,
        partialVisibilityGutter: itemsAvailable === 3 ? 0 : 20,
    },
    mobile2: {
        breakpoint: { max: 767, min: 460 },
        items: 3,
        slidesToSlide: 3,
        partialVisibilityGutter: itemsAvailable === 3 ? 0 : 20,
    },
    mobile1: {
        breakpoint: { max: 459, min: 376 },
        items: 2,
        slidesToSlide: 2,
        partialVisibilityGutter: itemsAvailable === 2 ? 0 : 20,
    },
    mobileXs: {
        breakpoint: { max: 375, min: 0 },
        items: 1,
        slidesToSlide: 1,
        partialVisibilityGutter: itemsAvailable === 1 ? 0 : 20,
    },
});
const getResponsiveSettingsSmall = (itemsAvailable) => ({
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 7,
        slidesToSlide: 7,
        partialVisibilityGutter: itemsAvailable === 7 ? 0 : 10,
    },
    tablet: {
        breakpoint: { max: 1023, min: 768 },
        items: 6,
        slidesToSlide: 6,
        partialVisibilityGutter: itemsAvailable === 6 ? 0 : 10,
    },
    mobile: {
        breakpoint: { max: 767, min: 600 },
        items: 3,
        slidesToSlide: 3,
        partialVisibilityGutter: itemsAvailable === 3 ? 0 : 10,
    },
    mobileXs: {
        breakpoint: { max: 600, min: 0 },
        items: 2,
        slidesToSlide: 2,
        partialVisibilityGutter: itemsAvailable === 2 ? 0 : 10,
    },
});
const VenueScreenList = (props) => {
    const { currentLocale, offers, hotelInformation, timezone, history, location, mainActivities, navigations, } = props;
    const [isMoving, setIsMoving] = (0, react_1.useState)(false);
    // const promiseParams = { locale: currentLocale, userToken: userData.token, days: 1 };
    const navigationsTypeUnordered = navigations.homePage
        .map((navigation) => navigation)
        .filter((item) => item.type === "offers" ||
        item.type === "activities" ||
        item.type === "directory");
    const navigationsType = placeActivitiesFirst(navigationsTypeUnordered);
    const showType = window.location.search.includes("dev-mode=true");
    // keeping this commented because we might want to use it in the future
    // useEffect( () => {
    //     fetchActivities();
    // }, [] );
    const renderActivitiesList = (activitiesItems, isMovingParameter) => {
        const activitiesForToday = filterActivitiesForToday(activitiesItems, timezone);
        const upcomingActivities = getUpcomingActivities(activitiesForToday);
        return upcomingActivities.map((item, index) => {
            const startTime = helpers_1.Helpers.getDateFromStringDependingLocale(item.start, currentLocale, timezone).time;
            const endTime = helpers_1.Helpers.getDateFromStringDependingLocale(item.end, currentLocale, timezone).time;
            const imgUrl = item.smallImage ? item.smallImage : null;
            return (react_1.default.createElement(material_1.Box, { key: (0, react_uid_1.uid)(index), className: "item-wrapper", onClick: (e) => {
                    if (isMovingParameter) {
                        return e.preventDefault();
                    }
                    return helpers_1.Helpers.openModal(modalEnums_1.default.ACTIVITY_DETAILS, {
                        content: item,
                    });
                } },
                imgUrl ? (react_1.default.createElement(material_1.Box, { className: "wrapper-image" },
                    react_1.default.createElement("img", { src: imgUrl, className: "item-image", alt: "Activity icon" }))) : (react_1.default.createElement("div", { className: "backup-gradient" })),
                react_1.default.createElement("div", { className: "item-texts" },
                    react_1.default.createElement(material_1.Typography, { className: "item-title", variant: "h6" },
                        " ",
                        item ? item.title : ""),
                    item.showStartTime && react_1.default.createElement(material_1.Typography, { className: "item-info", variant: "body2" },
                        startTime,
                        item.showEndTime && ` - ${endTime}`))));
        });
    };
    const renderOffersList = (offersItems, isMovingParameter) => offersItems.map((item, index) => {
        const content = renderItemContent(item);
        const type = Object.keys(item)[0];
        const imgUrl = item[type] &&
            item[type].images &&
            item[type].images[0] &&
            item[type].images[0]["1:1"] &&
            item[type].images[0]["1:1"].M
            ? item[type].images[0]["1:1"].M
            : null;
        const iconUrl = item[type] &&
            item[type].icon &&
            item[type].icon &&
            item[type].icon["1:1"] &&
            item[type].icon["1:1"].M
            ? item[type].icon["1:1"].M
            : null;
        return (react_1.default.createElement(material_1.Box, { key: (0, react_uid_1.uid)(index), className: "item-wrapper item-wrapper-small", 
            // eslint-disable-next-line consistent-return
            onClick: (e) => {
                if (isMovingParameter) {
                    return e.preventDefault();
                }
                if (item.folder) {
                    const redirectLocation = item.folder.deeplink
                        ? new URL(item.folder.deeplink).pathname
                        : `/directory/folder/${item.folder.title.toLowerCase().replace(/ /g, "-")}`;
                    return history.push({
                        pathname: redirectLocation,
                        search: location.search,
                    });
                }
                if (item.offer) {
                    return helpers_1.Helpers.openModal(modalEnums_1.default.DIRECTORY_AND_OFFER_DETAILS, {
                        activeItem: item.offer,
                    });
                }
                if (item.website) {
                    return helpers_1.Helpers.openModal(modalEnums_1.default.DIRECTORY_AND_OFFER_DETAILS, {
                        activeItem: item.website,
                    });
                }
            } },
            react_1.default.createElement("div", { className: "item-texts" },
                react_1.default.createElement(material_1.Typography, { className: "item-title", variant: "h6" },
                    content.titleItem,
                    " ",
                    `${showType ? `- ${type}` : ""}`)),
            imgUrl || iconUrl ? (react_1.default.createElement(material_1.Box, { className: "wrapper-image" },
                react_1.default.createElement("img", { src: iconUrl, className: "item-image", alt: "Offer icon" }))) : (react_1.default.createElement("div", { className: "backup-gradient" }))));
    });
    const renderDirectoriesList = (directoriesItems, isMovingParameter) => directoriesItems.map((item, index) => {
        const content = renderItemContent(item);
        const type = Object.keys(item)[0];
        const imgUrl = item[type] &&
            item[type].images &&
            item[type].images[0] &&
            item[type].images[0]["1:1"] &&
            item[type].images[0]["1:1"].M
            ? item[type].images[0]["1:1"].M
            : null;
        const iconUrl = item[type] &&
            item[type].icon &&
            item[type].icon &&
            item[type].icon["1:1"] &&
            item[type].icon["1:1"].M
            ? item[type].icon["1:1"].M
            : null;
        return (react_1.default.createElement(material_1.Box, { key: (0, react_uid_1.uid)(index), className: "item-wrapper item-wrapper-small", 
            // eslint-disable-next-line consistent-return
            onClick: (e) => {
                if (isMovingParameter) {
                    return e.preventDefault();
                }
                if (item.folder) {
                    const redirectLocation = item.folder.deeplink
                        ? new URL(item.folder.deeplink).pathname
                        : `/directory/folder/${item.folder.title.toLowerCase().replace(/ /g, "-")}`;
                    return history.push({
                        pathname: redirectLocation,
                        search: location.search,
                    });
                }
                if (item.page) {
                    return helpers_1.Helpers.openModal(modalEnums_1.default.DIRECTORY_AND_OFFER_DETAILS, {
                        activeItem: item.page,
                    });
                }
                if (item.website) {
                    return helpers_1.Helpers.openModal(modalEnums_1.default.DIRECTORY_AND_OFFER_DETAILS, {
                        activeItem: item.website,
                    });
                }
                if (item.document) {
                    return helpers_1.Helpers.openModal(modalEnums_1.default.DIRECTORY_AND_OFFER_DETAILS, {
                        activeItem: item.document,
                    });
                }
            } },
            react_1.default.createElement("div", { className: "item-texts" },
                react_1.default.createElement(material_1.Typography, { className: "item-title", variant: "h6" },
                    content.titleItem,
                    " ",
                    `${showType ? `- ${type}` : ""}`)),
            imgUrl || iconUrl ? (react_1.default.createElement(material_1.Box, { className: "wrapper-image" },
                react_1.default.createElement("img", { src: imgUrl || iconUrl, className: "item-image", alt: "Offer icon" }))) : (react_1.default.createElement("div", { className: "backup-gradient" }))));
    });
    const renderCarousel = (option) => {
        if (option === "activities") {
            const renderList = renderActivitiesList(mainActivities, isMoving);
            const showArrows = !(offers.length <= 3 ||
                !(window.innerWidth <= parseInt(globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_CONTENT)));
            return { renderList, showArrows };
        }
        if (option === "directory") {
            const renderList = renderDirectoriesList(hotelInformation, isMoving);
            const showArrows = !(hotelInformation.length <= 3 ||
                !(window.innerWidth <= parseInt(globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_CONTENT)));
            return { renderList, showArrows };
        }
        const renderList = renderOffersList(offers, isMoving);
        const showArrows = !(offers.length <= 3 ||
            !(window.innerWidth <= parseInt(globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_CONTENT)));
        return { renderList, showArrows };
    };
    return (react_1.default.createElement(WrapperList, null,
        react_1.default.createElement(material_1.Box, { className: "lists-content" }, navigationsType.map((item, key) => {
            const { showArrows, renderList } = renderCarousel(item.type);
            if (renderList.length === 0) {
                return null;
            }
            return (react_1.default.createElement(material_1.Box, { key: (0, react_uid_1.uid)(key) },
                react_1.default.createElement(material_1.Box, { className: "list-header" },
                    react_1.default.createElement(material_1.Typography, { className: "list-header-title", variant: "h6" }, item.type === "activities"
                        ? i18n_js_1.default.t("webapp_upcoming")
                        : item.title),
                    react_1.default.createElement(react_router_dom_1.Link, { to: `${window.location.pathname}/${item.type}`, className: "list-header-link" }, i18n_js_1.default.t("see_all"))),
                react_1.default.createElement(react_multi_carousel_1.default, { minimumTouchDrag: 20, className: `list-items ${item.type === "activities" ? "" : "carousel-wrapper-small"}`, partialVisible: true, swipeable: true, draggable: true, responsive: item.type === "activities"
                        ? getResponsiveSettings(renderList.length)
                        : getResponsiveSettingsSmall(renderList.length), arrows: showArrows, keyBoardControl: true, containerClass: "carousel-wrapper", centerMode: false, beforeChange: () => {
                        setIsMoving(true);
                    }, afterChange: () => {
                        setIsMoving(false);
                    } }, renderList),
                react_1.default.createElement("div", { className: "simple-scroller" }, renderList)));
        }))));
};
function filterActivitiesForToday(activities, timezone) {
    if (activities.length === 0) {
        return [];
    }
    const currentDate = new Date();
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return activities.filter((activity) => helpers_1.Helpers.convertDateToTimezone(activity.start, timezone, options) ===
        helpers_1.Helpers.convertDateToTimezone(currentDate.toString(), timezone, options));
}
function renderItemContent(item) {
    let titleItem;
    let image;
    if (item.offer) {
        titleItem = item.offer.title;
        image = item.offer.smallImage;
    }
    if (item.page) {
        titleItem = item.page.title;
        image = item.page.smallImage;
    }
    if (item.folder) {
        titleItem = item.folder.title;
        image = item.folder.smallImage;
    }
    if (item.website) {
        titleItem = item.website.title;
        image = item.website.smallImage;
    }
    if (item.document) {
        titleItem = item.document.title;
        image = item.document.smallImage;
    }
    return { titleItem, image };
}
function getUpcomingActivities(activities) {
    const currentDateUnixTime = Date.now();
    const upcomingActivities = activities.filter((activity) => {
        const activityStartUnixTime = new Date(activity.start).getTime();
        if (activityStartUnixTime < currentDateUnixTime) {
            return false;
        }
        return true;
    });
    return upcomingActivities;
}
function placeActivitiesFirst(lists) {
    const activityListIndex = lists.findIndex((list) => list.type === "activities");
    if (activityListIndex > 0) {
        return [
            lists[activityListIndex],
            ...lists.slice(0, activityListIndex),
            ...lists.slice(activityListIndex + 1),
        ];
    }
    return lists;
}
const mapStoreToProps = (store) => ({
    mainActivities: store.getValue("unfilteredActivities"),
    userData: store.getValue("userData"),
    offers: store.getValue("offers"),
    hotelInformation: store.getValue("directory"),
    currentLocale: store.getValue("currentLocale"),
    timezone: store.getValue("timezone"),
    navigations: store.getValue("navigations"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(VenueScreenList));
